<template>
  <div>
    <!-- Órdenes de trabajo -->
    <div class="row">
      <!-- Tarjeta por cada orden de trabajo -->
      <div
        v-for="orden in ordenes"
        :key="orden.orden_trabajo_id"
        class="col-sm-3 pr-0 mb-3"
      >
        <div
          class="card shadow-sm mr-3"
          style="border-radius: 10px; border: 1px solid #ccc;
          width: 260px; font-family: sans-serif; cursor: pointer;"
          @click="abrirModalAccion(orden)"
        >
          <!-- Encabezado dinámico -->
          <div
            :style="{
              backgroundColor: obtenerColorEstado(orden.estado_orden_id),
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              padding: '8px'
            }"
          >
            <div style="font-weight: bold; font-size: 0.85rem; color: #333;">
              N° O.T.: {{ orden.orden_trabajo_numero }}
            </div>
            <div style="display: flex; justify-content: space-between;
              align-items: center; font-size: 0.75rem; color: #555;">
              <span>Fecha: {{ orden.fecha_origen }}</span>
              <span style="font-size: 0.60rem; ">{{ orden.sucursal }}</span>
            </div>
          </div>

          <!-- Cuerpo -->
          <div style="padding: 12px;">
            <div style="font-weight: bold; font-size: 1rem; color: #000;">
              {{ orden.nombre }}
            </div>
            <p style="color: #a39d9d">
              {{ orden.servicio }}
            </p>
            <div style="display: flex; justify-content: space-between;
              align-items: center; margin-top: 8px;">
              <div style="font-size: 0.85rem; color: #333;">
                {{ orden.parametro }}
              </div>
              <div style="font-size: 0.8rem; color: #f7941d; font-weight: 500;">
                {{ orden.origen }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mensaje si no hay órdenes -->
      <div v-if="!ordenes.length" class="col-12">
        <div class="alert alert-info text-center">
          <i class="i-Information"></i>
          No hay órdenes de trabajo para mostrar
        </div>
      </div>
    </div>

    <theModalAccion ref="modalAccion" />
  </div>
</template>

<script>
import theModalAccion from './theModalAccion.vue';

export default {
  name: 'OrdenItemDoctor',
  components: {
    theModalAccion,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    ordenes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    obtenerColorEstado(estadoId) {
      // Mapeo de colores según estado
      const colores = {
        1: '#ffe100', // Amarillo - Pendiente
        2: '#28a745', // Verde - En proceso
        3: '#dc3545', // Rojo - Finalizado
        4: '#6c757d', // Gris - Cancelado
      };
      return colores[estadoId] || '#ffe100';
    },
    calcularTiempoTranscurrido(fechaCreacion) {
      if (!fechaCreacion) return null;

      const ahora = new Date();
      const creacion = new Date(fechaCreacion);
      const diffMs = ahora - creacion;

      // Convertir a horas
      const horas = Math.floor(diffMs / (1000 * 60 * 60));

      // Si es menos de 2 horas, no mostrar badge
      if (horas < 2) return null;

      // Mostrar en formato de horas
      return `${horas} H`;
    },
    irAOrden(ordenId) {
      // Navegar a la página de edición de la orden de trabajo
      this.$router.push({
        name: 'orden-trabajo-edit',
        params: { id: this.encrypt(ordenId) },
        query: {
          medico_id: this.encrypt(this.id),
          estado_orden_id: this.encrypt(1),
        },
      });
    },
    goToDoctor(id) {
      this.$router.push({ name: 'orden-trabajo-doctor', params: { id: this.encrypt(id) } });
    },
    encrypt(id) {
      return btoa(id);
    },
    abrirModalAccion(orden) {
      // Si el estado es 2 (Trabajando), navegar directamente sin abrir modal
      if (orden.estado_orden_id === 2) {
        const query = {
          estado_orden_id: this.encrypt(2),
          medico_id: this.encrypt(this.id),
          grupal: 'true',
        };
        if (orden.paciente_id) {
          query.paciente_id = this.encrypt(orden.paciente_id);
        }
        this.$router.push({
          name: 'orden-trabajo-doctor-edit',
          params: {
            id: this.encrypt(orden.orden_trabajo_id),
          },
          query,
        });
        return;
      }
      // Pasar grupal: true para que el modal sepa que viene de grupal
      this.$refs.modalAccion.show({ ...orden, grupal: true }, this.id);
    },
  },
};
</script>

<style scoped>
.bg-gray {
  background-color: rgba(232, 232, 232, 0.971);
}
.text-gray {
  color:#858189;
}
.border-radius {
  border-radius: 10px;
}
.line-height-1 {
  line-height: 1;
}

.card {
  width: 280px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow: hidden;
  font-family: 'Segoe UI', sans-serif;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  position: relative;
}

.card-header {
  padding: 8px 12px;
  color: white;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  position: relative;
}

.card-header.yellow {
  background-color: #fdd835;
  color: black;
}

.card-header.green {
  background-color: #388e3c;
}

.badge-rojo {
  background-color: #e53935;
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 8px;
}

.card-body {
  padding: 12px;
  background: white;
}

.nombre {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
}

.detalle {
  font-size: 14px;
  color: #444;
  margin-bottom: 6px;
}

.seccion {
  font-weight: bold;
  font-size: 14px;
  color: #f9a825;
}

.contador {
  font-weight: normal;
  color: #aaa;
  font-size: 13px;
}

</style>
